// components/tablecard/DynamicTableSimpleCustom.js
import React, { useRef } from "react";
import { CardBody } from "@material-tailwind/react";

const DynamicTableSimpleCustom = (props) => {
  const tableRef = useRef(null);

  let many = 0;
  if (props.data) {
    many = props.data.length;
  }
  let Yscroll = "";
  if (many > 20) {
    Yscroll = "h-screen";
  }

  // Fungsi untuk format waktu khusus
  const formatTimeOnly = (timeValue) => {
    if (!timeValue) return "";
    
    try {
      // Debug log
      console.log(`[Time Format] Input: ${timeValue}, Type: ${typeof timeValue}`);
      
      // Jika sudah format HH:MM:SS, ambil hanya HH:MM
      if (typeof timeValue === "string") {
        // Cek format HH:MM:SS
        if (/^\d{2}:\d{2}:\d{2}$/.test(timeValue)) {
          return timeValue.substring(0, 5); // Ambil hanya HH:MM
        }
        // Cek format HH:MM
        if (/^\d{2}:\d{2}$/.test(timeValue)) {
          return timeValue;
        }
        // Coba ekstrak dari string
        const match = timeValue.match(/(\d{1,2}):(\d{2})/);
        if (match) {
          const hours = match[1].padStart(2, '0');
          const minutes = match[2];
          return `${hours}:${minutes}`;
        }
      }
      
      return timeValue || "";
    } catch (error) {
      console.error("Error formatting time:", error, timeValue);
      return "";
    }
  };

  return (
    <>
      {!props.withoutAttribut ? (
        <div className="flex w-full justify-between px-4 pt-2 flex-col sm:flex-row mt-2">
          <div className="flex flex-row">
            {props.Master ? (
              <button
                className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white text-gray-800 font-semibold py-2 px-4 border border-main-100 hover:bg-main-100 hover:text-white rounded shadow"
                onClick={() => props.OnClick && props.OnClick({})}
              >
                Tambah +
              </button>
            ) : (
              <></>
            )}
          </div>
        </div>
      ) : (
        <></>
      )}

      <CardBody className="w-full pt-0 ">
        {props.data && props.data.length > 0 ? (
          <div className={"overflow-x-auto relative overflow-y-auto " + Yscroll}>
            <table
              className="table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-10"
              ref={tableRef}
            >
              <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  {props.header.map((data, id) => (
                    <th scope="col" className="py-3 px-6" key={"Header-" + id}>
                      {data.name}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {props.data.map((detail, id) => {
                  const classOdd = id % 2 === 0 
                    ? "bg-white border-b hover:bg-gray-200 hover:text-main-100"
                    : "bg-gray-50 border-b hover:bg-gray-200 hover:text-main-100";
                  
                  return (
                    <tr
                      className={classOdd}
                      key={`row-${id}`}
                      onClick={(e) => {
                        // Hanya panggil OnClick jika bukan klik tombol aksi
                        if (!e.target.closest('a, button') && props.OnClick) {
                          props.OnClick(detail);
                        }
                      }}
                    >
                      {props.header.map((data, idRow) => {
                        let texts = detail[data.key];
                        
                        // Handle modifiers
                        if (data.modifiers === "Date") {
                          try {
                            texts = new Date(detail[data.key]).toLocaleDateString("ID");
                          } catch (e) {
                            texts = detail[data.key];
                          }
                        } 
                        else if (data.modifiers === "EditDelete") {
                          return (
                            <td
                              key={`row-${id}-${idRow}`}
                              className="py-4 px-6 font-medium whitespace-nowrap"
                            >
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  props.edit && props.edit(detail, id);
                                }}
                                className="border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none cursor-pointer"
                              >
                                Edit
                              </button>
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  props.delete && props.delete(id);
                                }}
                                className="border text-white bg-red-700 hover:bg-white hover:border hover:border-red-700 hover:text-red-700 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none cursor-pointer"
                              >
                                Delete
                              </button>
                            </td>
                          );
                        } 
                        else if (data.modifiers === "Edit") {
                          return (
                            <td
                              key={`row-${id}-${idRow}`}
                              className="py-4 px-6 font-medium whitespace-nowrap"
                            >
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  props.edit && props.edit(detail, id);
                                }}
                                className="border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none cursor-pointer"
                              >
                                Edit
                              </button>
                            </td>
                          );
                        } 
                        else {
                          // Handle custom modifiers
                          switch (data.modifiers) {
                            case "timeonly":
                              texts = formatTimeOnly(texts);
                              break;
                            case "dateOnly":
                              try {
                                const date = new Date(texts);
                                const day = date.getDate();
                                const month = date.getMonth() + 1;
                                const year = date.getFullYear();
                                texts = `${day}/${month}/${year}`;
                              } catch (e) {
                                texts = texts;
                              }
                              break;
                            case "Numbers":
                              try {
                                texts = parseFloat(texts || 0).toLocaleString("in-ID", { 
                                  maximumFractionDigits: 0 
                                });
                              } catch (e) {
                                texts = texts;
                              }
                              break;
                            default:
                              // Tidak ada perubahan untuk modifier lainnya
                              break;
                          }
                          
                          return (
                            <td
                              key={`row-${id}-${idRow}`}
                              className={`py-4 px-6 font-medium whitespace-nowrap ${
                                data.modifiers === "Numbers" ? "text-right" : "text-left"
                              }`}
                            >
                              {texts || ""}
                            </td>
                          );
                        }
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : props.data ? (
          <div className="text-center py-8 text-gray-500">
            Tidak ada data untuk ditampilkan
          </div>
        ) : (
          <div className="text-center py-8">
            <div className="inline-block animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-main-100"></div>
            <p className="mt-4 text-gray-600">Memuat data...</p>
          </div>
        )}
      </CardBody>
    </>
  );
};

export default DynamicTableSimpleCustom;